import RequestAbstract from "../abstract";

export default class PublicAppealHasComments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-appeal-has-comments";
    }

}
